"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueries, useQuery } from "@tanstack/react-query";
import { getReferentPriceEntries, type ReferentPriceEntry } from "@/entities/referent-price/api/referent-prices";
const STALE_TIME_MS = 5 * 60 * 1000;
function buildQueryOptions(medicineId: string | number | null | undefined) {
  return {
    queryKey: ["referent-prices", medicineId == null ? null : String(medicineId)] as const,
    enabled: medicineId != null && String(medicineId).length > 0,
    queryFn: () => getReferentPriceEntries(medicineId as string | number),
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false
  };
}
export function useReferentPrice(medicineId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== medicineId) {
    t0 = buildQueryOptions(medicineId);
    $[0] = medicineId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}
export function useReferentPrices(medicineIds) {
  const $ = _c(13);
  let t0;
  if ($[0] !== medicineIds) {
    t0 = medicineIds.map(_temp);
    $[0] = medicineIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const queries = useQueries(t1);
  let byMedicineId;
  if ($[4] !== medicineIds || $[5] !== queries) {
    byMedicineId = new Map();
    medicineIds.forEach((id_0, index) => {
      byMedicineId.set(String(id_0), queries[index]?.data ?? []);
    });
    $[4] = medicineIds;
    $[5] = queries;
    $[6] = byMedicineId;
  } else {
    byMedicineId = $[6];
  }
  let t2;
  if ($[7] !== queries) {
    t2 = queries.some(_temp2);
    $[7] = queries;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const isLoading = t2;
  let t3;
  if ($[9] !== byMedicineId || $[10] !== isLoading || $[11] !== queries) {
    t3 = {
      queries,
      byMedicineId,
      isLoading
    };
    $[9] = byMedicineId;
    $[10] = isLoading;
    $[11] = queries;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp2(q) {
  return q.isLoading;
}
function _temp(id) {
  return buildQueryOptions(id);
}